import {Cloneable} from "@/common/Cloneable";
import {alias, createModelSchema, custom, deserialize, list, serialize, SKIP} from "serializr";
import {Range} from "@/modules/redactor/models/utils/Range";
import {Schema} from "@/common/Schema";


export class PlinkoSpringConfig extends Cloneable {

    static schema() {
        return custom((v) => {
            return v && !v.empty() ? serialize(PlinkoSpringConfig, v) : SKIP;
        }, (v) => {
            return deserialize(PlinkoSpringConfig, v);
        });
    }

    constructor() {
        super();

        this._shotImpulse = null;
        this._shotDeviation = null;
        this._touchImpulse = null;
        this._excludeImpulse = [];
    }

    get shotImpulse() {
        return this._shotImpulse;
    }

    set shotImpulse(value) {
        this._shotImpulse = value;
    }

    get shotDeviation() {
        return this._shotDeviation;
    }

    set shotDeviation(value) {
        this._shotDeviation = value;
    }

    get touchImpulse() {
        return this._touchImpulse;
    }

    set touchImpulse(value) {
        this._touchImpulse = value;
    }

    get excludeImpulse() {
        return this._excludeImpulse;
    }

    set excludeImpulse(value) {
        this._excludeImpulse = value;
    }

    get excludeImpulseString() {
        if (this.excludeImpulse) {
            return this.excludeImpulse.join(";");
        }
        return "";
    }

    set excludeImpulseString(value) {
        if (!value || value.length === 0) {
            this.excludeImpulse = [];
        } else {
            this.excludeImpulse = value.split(";").map(Number).filter(v => v > 0);
        }
    }

    valid() {

        if (!this.shotImpulse || this.shotImpulse.lower <= 0 || this.shotImpulse.empty()) {
            return false;
        }

        if (this.shotDeviation && !this.shotDeviation.valid(true)) {
            return false;
        }

        if (!this.touchImpulse || this.touchImpulse.lower <= 0 || this.touchImpulse.empty()) {
            return false;
        }

        if (this.excludeImpulse && this.excludeImpulse.some(v => !Number.isInteger(v) || v <= 0)) {
            return false;
        }

        return true;
    }

    empty() {
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new PlinkoSpringConfig());
        } else if (target instanceof PlinkoSpringConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(PlinkoSpringConfig, {
    _shotImpulse: alias("shot_impulse", Range.schema()),
    _shotDeviation: alias("shot_deviation", Range.schema()),
    _touchImpulse: alias("touch_impulse", Range.schema()),
    _excludeImpulse: alias("exclude_impulse", list(Schema.primitive())),
});